export default {
  loading: false,
  categories: [],
  category: {},
  totalCount: 0,
};
